import { render, staticRenderFns } from "./CalendariosPantalla.vue?vue&type=template&id=a8a0eb16&"
import script from "./CalendariosPantalla.vue?vue&type=script&lang=ts&"
export * from "./CalendariosPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports